module.exports = __webpack_public_path__ + "img/Raytheon-Emblem 1 (Traced).98778db4.svg";